module.exports = __webpack_public_path__ + "static/DocFX-1e47a084ad1ff5134793004c186d0d19.svg";